import baseRequest from "../_core/baseRequest";

// Backend payment-transaction-log endpoint'lerinde invoiceId'yi body'den değil query'den okuyor
const splitInvoiceIdQuery = ({invoiceId, ...body} = {}) => ({
    body,
    config: invoiceId ? {params: {invoiceId}} : null
});

const UNESCAPED_BY_ENCODE_URI = {"!": "%21", "'": "%27", "(": "%28", ")": "%29", "*": "%2A"};

const encodeStrict = value =>
    encodeURIComponent(value).replace(/[!'()*]/g, char => UNESCAPED_BY_ENCODE_URI[char]);

const strictParamsConfig = params => ({
    params,
    paramsSerializer: query =>
        Object.entries(query || {})
            .filter(([, value]) => value !== undefined && value !== null && value !== "")
            .map(([key, value]) => `${encodeStrict(key)}=${encodeStrict(value)}`)
            .join("&")
});

export default {
    getSubCompanyCaris: params => baseRequest.get(`subcompany/getCaris/${params.subCompanyId}`),
    getCompanyList: params => {
        return baseRequest.get(
            `/company?offset=${params.skip}&limit=${params.limit}&activity=${
                params.activity
            }&onboardingStatus=${params.onboardingStatus}${
                params.searchText ? "&searchText=" + params.searchText : ""
            }`
        );
    },
    getSubCompanyList: params =>
        baseRequest.get(
            `/company/sub?${params.companyId ? `companyId=${params.companyId}` : ""}&offset=${
                params.skip
            }&limit=${params.limit}&activity=${params.activity}${
                params.vehicleType ? "&vehicleType=" + params.vehicleType : ""
            }${params.city ? "&city=" + params.city : ""}${
                params.searchText ? "&searchText=" + params.searchText : ""
            }${params.companies ? "&companies=" + params.companies : ""}
                `
        ),
    getSubcompanyPageList: params => baseRequest.post(`/subcompany/list`, params),
    getSubcompanyUsers: params =>
        baseRequest.get(`company/subcompany/panel-users-by-subcompany/${params.subcompanyId}`),
    getMyCompanyInfo: params => baseRequest.get(`company/info/${params.companyId}`),
    getSubcompanyDetail: params => baseRequest.get(`/subcompany/details/${params?.subcompanyId}`),
    updateSubcompanyDetail: params => baseRequest.post(`/subcompany/details`, params),
    updateCreditAlertLimit: params =>
        baseRequest.post(`/subcompany/updateCreditAlertLimit`, params),
    updateMinCreditLoadLimit: params =>
        baseRequest.post(`/subcompany/update-min-credit-load-limit`, params),
    getSubCompanyMapList: params =>
        baseRequest.get(
            `/company/subcompanymaplist?${params.disabled ? "disabled=" + params.disabled : ""}${
                params.companyId ? "&companyId=" + params.companyId : ""
            }${params.city ? "&city=" + params.city : ""}${
                params.zoneManagementId ? "&zoneManagementId=" + params.zoneManagementId : ""
            }${params.zoneId ? "&zoneId=" + params.zoneId : ""}`
        ),
    getCompany: params =>
        baseRequest.get(
            `/company/${params.companyId}/${params.withSubCompanies}${
                params.vehicleType ? "?vehicleType=" + params.vehicleType : ""
            }`
        ),
    generateCompanyCode: () => baseRequest.get(`/company/generate-company-code`),
    getSubCompany: params => baseRequest.get(`/company/subcompany/${params.subCompanyId}`),
    getSubcompanyDetailOptions: () => baseRequest.get(`/subcompany/subcompany-detail/options`),
    getSubCompanyPaymentContracts: params =>
        baseRequest.post(`/company/subcompany/payment-contract/list`, params),
    getUploadedSubCompanyPaymentContract: params =>
        baseRequest.get(
            `/company/subcompany/payment-contract/${params.contractId}/download`,
            params
        ),

    getLatestSubCompanyPaymentContractFile: params =>
        baseRequest.get(
            `/company/subcompany/payment-contract-files/${params.subCompanyId}/latest`,
            params
        ),
    downloadSubCompanyPaymentContractFile: params =>
        baseRequest.get(
            `/company/subcompany/payment-contract-files/${params.paymentContractFileId}/download`,
            params
        ),
    uploadSubCompanyPaymentContractFile: params => {
        const formData = new FormData();
        formData.append("file", params.file);
        formData.append("subCompanyId", params.subCompanyId);
        return baseRequest.post(`/company/subcompany/payment-contract-files`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },

    getSubCompanyPaymentTransactionLogList: params => {
        const isExcelRequest = params?.excel === true || params?.excelV2 === true;
        const {body, config} = splitInvoiceIdQuery(params);
        return baseRequest.request(
            "POST",
            `/company/subcompany/payment-transaction-log/list`,
            body,
            isExcelRequest ? "blob" : null,
            config,
            isExcelRequest
        );
    },
    getSubCompanyPaymentTransactionLogForClient: params =>
        baseRequest.post(`/company/subcompany/payment-transaction-log-for-client/list`, params),
    getCompanyCariRecords: params => baseRequest.post(`/company/listCariRecords`, params),
    getCompanyCariLogs: params => baseRequest.post(`/company/listCariLogs`, params),
    createSubCompanyPaymentContract: params =>
        baseRequest.post(`/company/subcompany/payment-contract/create`, params),
    recalculateSubCompanyPaymentContract: params =>
        baseRequest.post(`/company/subcompany/payment-contract/recalculate`, params),
    cancelSubCompanyPaymentContract: params =>
        baseRequest.post(`/company/subcompany/payment-contract/cancel`, params),
    generateSubCompanyCode: params =>
        baseRequest.post("company/subcompany/generate-subcompany-code", params),
    createCompany: params => baseRequest.post("/company", params),
    createSubCompany: params => baseRequest.post("/company/subcompany", params),
    updateSubCompany: params => baseRequest.put(`/company/subcompany`, params),
    updateSubCompanyAuthorizedID: params =>
        baseRequest.put(`/company/subcompany/authorized-id`, params),
    updateSubCompanyStatus: params => baseRequest.post(`/company/sub`, params),
    changeSubCompanyOnboardingStatus: params =>
        baseRequest.put(`/company/subcompany/changeOnboardingStatus`, params),
    createObjectionsCreditLog: params =>
        baseRequest.post(`/company/subcompany/payment-transaction/objection`, params),
    getObjectionsCreditLog: params =>
        baseRequest.post(`/company/subcompany/payment-transaction/getObjections`, params),
    approveObjection: params =>
        baseRequest.post(`/company/subcompany/payment-transaction/approveObjection`, params),
    rejectObjection: params =>
        baseRequest.post(`/company/subcompany/payment-transaction/rejectObjection`, params),
    updateSubCompanyMergeOptions: params =>
        baseRequest.post(`company/subcompany/updatemergeoptions`, params),
    updateSubCompanyCredit: params => baseRequest.post(`company/subcompany/updateCredit`, params),
    updateSubCompanyQueueOptions: params =>
        baseRequest.post(`company/subcompany/updatequeueoptions`, params),
    updateSubCompanyDistanceNotificationOptions: params =>
        baseRequest.post(`company/subcompany/update-shift-options`, params),
    updateSubCompanyProofOfDelivery: params =>
        baseRequest.post(`company/subcompany/updateproofofdelivery`, params),
    updateSubCompanyTrackingOptions: params =>
        baseRequest.post(`company/subcompany/sms-tracking-options`, params),
    updateSubCompanyDynamicPriceOptions: params =>
        baseRequest.post(`company/subcompany/update-dynamic-price-options`, params),
    updateSubCompanyVerificationOptions: params =>
        baseRequest.post(`company/subcompany/delivery-verification-options`, params),
    updateSubCompanySlotOrderOptions: params =>
        baseRequest.post(`company/subcompany/update-slot-options`, params),
    updateCompany: params => baseRequest.put(`/company/${params._id}`, params),
    updateCompanyMergeOptions: params =>
        baseRequest.put(`/company/updatemergeoptions/${params._id}`, params),
    updateCompanyQueueOptions: params =>
        baseRequest.put(`/company/updatequeueoptions/${params._id}`, params),
    updateCompanyDistanceNotificationOptions: params =>
        baseRequest.put(`/company/update-shift-options/${params._id}`, params),
    updateCompanyProofOfDelivery: params =>
        baseRequest.put(`/company/updateproofofdelivery/${params._id}`, params),
    updateCompanyTrackingOptions: params =>
        baseRequest.put(`/company/sms-tracking-options/${params._id}`, params),
    updateCompanyDynamicPriceOptions: params =>
        baseRequest.put(`/company/update-dynamic-price-options/${params._id}`, params),
    updateCompanyVerificationOptions: params =>
        baseRequest.put(`/company/delivery-verification-options/${params._id}`, params),
    updateCompanySlotOrderOptions: params =>
        baseRequest.put(`/company/update-slot-options/${params._id}`, params),
    updateLocationCheckOptions: params =>
        baseRequest.put(`/company/location-check-options/${params._id}`, params),
    updateCompanyBarcodeOptions: params =>
        baseRequest.put(`/company/barcode-options/${params._id}`, params),
    deleteCompany: params => baseRequest.delete(`/company/${params.companyId}`),
    uploadImage: params => baseRequest.uploadFile("company/uploadimage", params),
    uploadMarkerImage: params => baseRequest.uploadFile("company/uploadmarkerimage", params),
    downloadSubCompanyExcelFile: params =>
        baseRequest.post(
            `/company/subcompany/exportsubcompanylist/${params.companyId}`,
            null,
            true
        ),
    updateCutOffOptions: params =>
        baseRequest.put(`/company/cut-off-options/${params._id}`, params),
    updateShiftSuggestionOptions: params =>
        baseRequest.put(`/company/shift-suggestion-options/${params._id}`, params),
    sendApiGuidelineEmail: params => baseRequest.post("/company/send-api-guideline-email", params),
    transferSubcompanyToAnotherCompany: params =>
        baseRequest.post(`/subcompany/transfer-subcompany-to-another-company`, params),
    //#region Platform Integrations
    listSubcompanyIntegrationsFields: () =>
        baseRequest.get(`/company/subcompany/integrations/fields`),
    listSubcompanyIntegrations: params =>
        baseRequest.get(`/company/subcompany/${params?.subCompanyId}/integrations`),
    createSubcompanyIntegration: params =>
        baseRequest.post(`/company/subcompany/${params?.subCompanyId}/integrations`, params),
    updateSubcompanyIntegration: params =>
        baseRequest.put(`/company/subcompany/${params?.subCompanyId}/integrations`, params),
    deleteSubcompanyIntegration: params =>
        baseRequest.post(`/company/subcompany/${params?.subCompanyId}/integrations/remove`, params),
    healthCheckSubcompanyIntegration: params =>
        baseRequest.post(
            `/company/subcompany/${params?.subCompanyId}/integrations/health-check`,
            params
        ),
    listIntegrationsPaymentTypes: () =>
        baseRequest.get(`/company/subcompany/integrations/payment-types`),
    //#endregion

    // Yemek Kartı Entegrasyonları kaldırıldı (kullanılmıyor).
    // //#region Meal Card Integrations
    // listSubcompanyMealCardIntegrationsFields: () =>
    //     baseRequest.get(`/company/subcompany/meal-card-integrations/fields`),
    // listSubcompanyMealCardIntegrations: params =>
    //     baseRequest.get(`/company/subcompany/${params?.subCompanyId}/meal-card-integrations`),
    // createSubcompanyMealCardIntegration: params =>
    //     baseRequest.post(
    //         `/company/subcompany/${params?.subCompanyId}/meal-card-integrations`,
    //         params
    //     ),
    // updateSubcompanyMealCardIntegration: params =>
    //     baseRequest.put(
    //         `/company/subcompany/${params?.subCompanyId}/meal-card-integrations`,
    //         params
    //     ),
    // deleteSubcompanyMealCardIntegration: params =>
    //     baseRequest.post(
    //         `/company/subcompany/${params?.subCompanyId}/meal-card-integrations/remove`,
    //         params
    //     ),
    // //#endregion

    getFalseCompanyRecordList: params => {
        return baseRequest.get(
            `/company/false-records?offset=${params.skip}&limit=${params.limit}${
                params.searchText ? "&searchText=" + params.searchText : ""
            }`
        );
    },
    createPaymentLink: params => {
        return baseRequest.post(`/bulutfon/createPaymentLink`, params);
    },
    listPayments: params => {
        return baseRequest.post(`/subcompany/listPayments`, params);
    },
    //#endregion

    //#region COD Payment Settings
    updateSubCompanyCodPaymentSettings: params => {
        return baseRequest.put(`/subCompany/${params?.subCompanyId}/cod-payment-settings`, params);
    },
    //#endregion

    updateSubcompanyPaymentInfo: params => {
        return baseRequest.put(
            `/subCompany/${params?.subCompanyId}/payment-info/${params?.paymentType}`,
            params
        );
    },
    updateSubCompanyReadyOrderNotificationSettings: params => {
        return baseRequest.put(
            `/subcompany/${params?.subCompanyId}/ready-order-notification-settings`,
            params
        );
    },
    updateSubCompanyCodPaymentMethodsSelfSelectionFeatureStatus: params => {
        return baseRequest.put(
            `/subCompany/${params?.subCompanyId}/cod-payment-methods/self-selection-feature-status`,
            params
        );
    },
    updateSubCompanyCodPaymentMethodsSelfSelection: params => {
        return baseRequest.put(
            `/subCompany/${params?.subCompanyId}/cod-payment-methods/self-selection`,
            params
        );
    },
    getSubcompanyCodPaymentList: params =>
        baseRequest.post("/subCompany/cod-payment/list", {...params}),
    getSubCompanyPricingList: params => baseRequest.post("/subcompany/pricing-list", {...params}),
    paymentTransactionsLogCalculation: params => {
        const {body, config} = splitInvoiceIdQuery(params);
        return baseRequest.request(
            "POST",
            "/company/subcompany/payment-transaction-log-calculations",
            body,
            null,
            config
        );
    },
    paymentTransactionLogDetails: params => {
        const {body, config} = splitInvoiceIdQuery(params);
        return baseRequest.request(
            "POST",
            "/company/subcompany/payment-transaction-log-details",
            body,
            null,
            config
        );
    },
    transactionTypes: () =>
        baseRequest.get("/company/subcompany/payment-transaction-log/transaction-types"),
    subTypes: () => baseRequest.get("/company/subcompany/payment-transaction-log/sub-types"),
    invoiceStatuses: () =>
        baseRequest.get("/company/subcompany/payment-transaction-log/invoice-statuses"),
    providerCompanies: () =>
        baseRequest.get("/company/subcompany/payment-transaction-log/provider-companies"),
    creditModes: () => baseRequest.get("/company/subcompany/payment-transaction-log/credit-modes"),
    creditModeFilters: () =>
        baseRequest.get("/company/subcompany/payment-transaction-log/credit-mode-filters"),
    getCompanyInvoiceDashboard: params =>
        baseRequest.get("/company-invoices/dashboard", strictParamsConfig(params)),
    getCompanyInvoiceList: params =>
        baseRequest.get("/company-invoices/list", strictParamsConfig(params)),
    getCompanyInvoiceSubCompanies: ({companyId, ...params}) =>
        baseRequest.get(`/company-invoices/${companyId}/sub-companies`, strictParamsConfig(params)),
    exportCompanyInvoices: params =>
        baseRequest.get("/company-invoices/export", strictParamsConfig(params)),
    getCompanyInvoiceDetails: ({subCompanyId, ...params}) =>
        baseRequest.get(`/company-invoices/${subCompanyId}/details`, strictParamsConfig(params)),
    sendCompanyInvoicesToNetsis: params =>
        baseRequest.post("/company-invoices/send-to-netsis", params)
};
